import ApiService from '../services/ApiService';
import FileService from '../services/FileService';
import * as camelcaseKeys from 'camelcase-keys';

export default class EventRepository {
    constructor() {
        this.apiService = new ApiService();
        this.fileService = new FileService();
    }

    createEvent(data) {
        data = this.transformEventDataForRequest(data);
        return new Promise((resolve, reject) => {
            this.apiService
                .post('events', data)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteEvent(id) {
        return new Promise((resolve, reject) => {
            this.apiService
                .delete('events/' + id)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getEvent(id) {
        return new Promise((resolve, reject) => {
            this.apiService
                .get('events/' + id)
                .then(response =>
                    resolve(this.transformResponseToEvent(response))
                )
                .catch(error => reject(error));
        });
    }

    getEvents(sort) {
        return new Promise((resolve, reject) => {
            this.apiService
                .get('events?no-pagination=true&sort=' + sort)
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    }

    transformEventDataForRequest(data, method = null) {
        if (data.image) {
            data.image = this.fileService.convertBase64ToFIle(
                data.image,
                data.imageName
            );
        }

        if (data.video) {
            data.video = this.fileService.convertBase64ToFIle(
                data.video,
                data.videoName
            );
        }

        if (data.tags) {
            data.tags = JSON.stringify(data.tags);
        }

        return this.apiService.convertDataToFormData(data, method);
    }

    transformResponseToEvent(event) {
        event = camelcaseKeys(event);
        event.imageUrl = event.image;
        event.videoUrl = event.video;

        return event;
    }

    updateEvent(id, data) {
        data = this.transformEventDataForRequest(data, 'PUT');

        return new Promise((resolve, reject) => {
            this.apiService
                .post('events/' + id, data)
                .then(response =>
                    resolve(this.transformResponseToEvent(response))
                )
                .catch(error => reject(error));
        });
    }
}
